import React from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import CustomField from "../../Common/Form/CustomField";

const ProductFilters = ({ filters, setFilters }) => {
  const handleSubmit = (values) => {
    setFilters(values);
  };

  return (
    <Box w={"100%"}>
      <Box flex="1" textAlign="left">
        <Heading variant="h2">Filtros</Heading>
      </Box>

      <Formik
        initialValues={filters}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
          handleSubmit(values);
          actions.setSubmitting(false);
        }}
      >
        {(props) => (
          <Form>
            <Flex
              spacing="50px"
              align="left"
              flexDirection={["column", "column", "row"]}
              justifyContent="space-around"
              gap={"0.75rem"}
            >
              <CustomField
                name="dateFrom"
                type="date"
                title="Desde"
                props={props}
                customFontColor="menu.700"
              ></CustomField>
              <CustomField
                name="dateUntil"
                type="date"
                title="Hasta"
                props={props}
                customFontColor="menu.700"
              ></CustomField>

              <Box align="center">
                <Button
                  mt={4}
                  colorScheme="teal"
                  isLoading={props.isSubmitting}
                  type="submit"
                >
                  Filtrar
                </Button>
              </Box>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ProductFilters;
